<!-- Footer principal -->
<footer class="footer-main">
  <div class="container">
    <div class="footer-grid">

      <!-- Columna 1: Logo -->
      <div class="footer-column">
        <div class="footer-logo">
          <img src="assets/img/logos/main_logo.svg" alt="LightCap Group">
        </div>
      </div>

      <!-- Columna 2: Contacto -->
      <div class="footer-column">
        <div class="footer-contact-item">
          <i class="fas fa-home"></i>
          <span>Buenos Aires, Argentina</span>
        </div>
        <div class="footer-contact-item">
          <i class="fas fa-envelope"></i>
          <a href="mailto:contacto@lightcapgroup.com.ar">contacto@lightcapgroup.com.ar</a>
        </div>
        <div class="footer-contact-item">
          <i class="fas fa-phone"></i>
          <a
            href="https://api.whatsapp.com/send/?phone=5491127759760&text=Hola%21+Me+gustar%C3%ADa+obtener+m%C3%A1s+informaci%C3%B3n+sobre+sus+servicios.&type=phone_number&app_absent=0">54
            (911) 2775-9760</a>
        </div>
      </div>

      <!-- Columna 3: Redes Sociales -->
      <div class="footer-column">
        <div class="footer-social-title">Seguinos en</div>
        <div class="footer-social-icons">
          <a href="https://www.facebook.com/..." target="_blank"><i class="fab fa-facebook-f"></i></a>
          <a href="https://www.instagram.com/..." target="_blank"><i class="fab fa-instagram"></i></a>
          <a href="https://www.linkedin.com/..." target="_blank"><i class="fab fa-linkedin-in"></i></a>
          <a href="https://www.youtube.com/..." target="_blank"><i class="fab fa-youtube"></i></a>
          <a href="https://open.spotify.com/..." target="_blank"><i class="fab fa-spotify"></i></a>
        </div>
      </div>

      <!-- Columna 4: Newsletter -->
      <div class="footer-column footer-newsletter">
        <div class="substack-container">
          <iframe src="https://lightcapgroupok.substack.com/embed?transparent=1&light=1" width="100%" height="320"
            style="border:0;" scrolling="no">
          </iframe>
        </div>
      </div>

    </div>
  </div>
</footer>